import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { aggregateMetricSeries, formatMetric, metricNumber, metricSegments } from '../../lib/socialMetrics.js';
import { smoothMetricPath } from '../../lib/chartPaths.js';
import { MetricSeriesTable, MetricValue } from './MetricValue.jsx';

export default function MetricSeriesChart({ data = [] }) {
  const { t, i18n } = useTranslation();
  const [field, setField] = useState('views');
  const [hover, setHover] = useState(null);
  const label = t(`socialMetrics.${field}`);
  const fields = ['views', 'impressions', 'reach'];
  const max = Math.max(1, ...data.map(row => metricNumber(row[field]) ?? 0)) * 1.1;
  const xy = (index, value) => [28 + index / Math.max(1, data.length - 1) * 704, 198 - value / max * 176];
  const segments = metricSegments(data, field, xy);
  const total = aggregateMetricSeries(data);
  return <div>
    <div className="an-subtabs" role="group" aria-label={t('socialMetrics.metric')}>
      {fields.map(key => <button key={key} type="button" aria-pressed={field === key} className={field === key ? 'is-active' : ''} onClick={() => { setField(key); setHover(null); }}>{t(`socialMetrics.${key}`)}</button>)}
    </div>
    <div className="an-stats"><div><div className="an-cs-l">{label}</div><div className="an-cs-v"><MetricValue metrics={total} field={field} /></div></div></div>
    <div className="an-svg-wrap" onMouseLeave={() => setHover(null)} onMouseMove={event => {
      const rect = event.currentTarget.getBoundingClientRect();
      setHover(Math.max(0, Math.min(data.length - 1, Math.round(((event.clientX - rect.left) / rect.width * 760 - 28) / 704 * (data.length - 1)))));
    }}>
      <svg className="an-svg" viewBox="0 0 760 220" role="img" aria-label={`${label}. ${t('socialMetrics.chartHint')}`}>
        {[22, 66, 110, 154, 198].map(y => <line key={y} x1="28" x2="732" y1={y} y2={y} stroke="var(--border-subtle)" />)}
        {segments.map((points, index) => <g key={index} data-metric-segment={field}>
          {points.length > 1 && <path d={smoothMetricPath(points)} fill="none" stroke="var(--accent)" strokeWidth="2.4" />}
          {points.map(([x, y], i) => <circle key={i} cx={x} cy={y} r="3" fill="var(--accent)" />)}
        </g>)}
      </svg>
      {hover != null && data[hover] && (() => {
        const left = (xy(hover, 0)[0] / 760) * 100;
        return <div className="an-tip" style={{ left: `${left}%`, transform: `translateX(-${left}%)` }}>
        <div className="an-tip-l">{data[hover].date}</div>
        <div className="an-tip-row an-tip-row--plain"><span>{label}</span><b>{data[hover][field] == null ? t('socialMetrics.unavailable') : formatMetric(data[hover][field], i18n.language)}</b></div>
      </div>;
      })()}
    </div>
    <details className="chart-data-details"><summary>{t('engagementChart.dataDetails')}</summary><div className="chart-data-details-body"><p>{t('socialMetrics.snapshotHint')}</p><p>{t('socialMetrics.chartHint')}</p></div></details>
    <MetricSeriesTable data={data} fields={fields.map(key => ({ key, label: t(`socialMetrics.${key}`) }))} label={label} />
  </div>;
}
